export const INACTIVITY_INTERVAL_MS = 1000 * 60 * 5; // 5min (in milliseconds)

export default {};
